module.exports = __webpack_public_path__ + "kudos_38.svg?34e5ec093095912354fbf5f160892697";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_38.svg
// module id = 137
// module chunks = 0